export default function CallandRegisterComponent({
  heading = "Talk to our Counsellor",
  buttonText = "Register Now",
  buttonLink = "/apply",
  phoneDisplay = "",
  whatsappLink = "",
  extraHtml = ""
}) {
  return (
    <div className="p-4 rounded-xl shadow">
      <h3 className="text-xl font-bold mb-3">{heading}</h3>
      {phoneDisplay && <p className="mb-2">📞 {phoneDisplay}</p>}
      {whatsappLink && <a className="underline" href={whatsappLink} target="_blank" rel="noreferrer">Chat on WhatsApp</a>}
      <div className="mt-4">
        <a href={buttonLink} className="px-4 py-2 bg-green-600 text-white rounded-lg">{buttonText}</a>
      </div>
      {extraHtml && <div className="prose mt-4" dangerouslySetInnerHTML={{__html: extraHtml}} />}
    </div>
  );
}
